import { render, staticRenderFns } from "./TasksShortTable.component.vue?vue&type=template&id=19090290&scoped=true&"
import script from "./TasksShortTable.component.vue?vue&type=script&lang=js&"
export * from "./TasksShortTable.component.vue?vue&type=script&lang=js&"
import style0 from "./TasksShortTable.component.vue?vue&type=style&index=0&id=19090290&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19090290",
  null
  
)

export default component.exports